module.exports = "<app-main-nav>\n  <router-outlet></router-outlet>\n</app-main-nav>\n"